import React, { FunctionComponent, useCallback } from 'react';

import cn from 'classnames';

import { UatraitsState } from '../../../../../../../types/common';
import Phone from '../../../../../images/touch-stub/Phone.png';
import Phone2x from '../../../../../images/touch-stub/Phone2x.png';
import Phone3x from '../../../../../images/touch-stub/Phone3x.png';
import { i18n } from '../../../../helpers/i18n';
import { useAppStoreLink } from '../../../../hooks/useAppStoreLink';
import { useConferenceId } from '../../../../hooks/useConferenceId';
import Button from '../../../button';
import css from './index.css';

interface UnsupportedTouchErrorPage {
    BrowserName: UatraitsState['BrowserName'];
}

// для непопулярных браузеров показываем дополнительно кнопку - Открыть в приложении(открывающее схему),
// а текст желтой кнопки Попробовать заменяем на - Установить приложение
const POPULAR_BROWSERS = ['ChromeMobile', 'YandexBrowser', 'MobileFirefox', 'MobileSafari', 'YandexSearch'];

export const UnsupportedTouchErrorPage: FunctionComponent<UnsupportedTouchErrorPage> = ({ BrowserName }) => {
    const appStoreLink = useAppStoreLink();
    const confId = useConferenceId();

    const goToAppStore = useCallback(() => {
        if (appStoreLink) {
            window.location.assign(appStoreLink);
        }
    }, [appStoreLink]);

    const openApp = useCallback(() => {
        window.location.href = 'telemost://' + (confId ? 'j/' + confId : 'start');
    }, [confId]);

    const isPopularBrowser = POPULAR_BROWSERS.includes(BrowserName);
    const titleYellowButton = !isPopularBrowser ? i18n('common', 'install-app') : i18n('common', 'try-app');

    return (
        <div className={css.container}>
            <div className={css.underlay}>
                <span className={css.title}>{i18n('error-page', 'try-telemost-app')}</span>
                <span className={css.subtitle}>{i18n('error-page', 'unsupported-mobile-bro-videocalls')}</span>
                <img className={css.phoneImg} src={Phone} srcSet={`${Phone2x} 2x, ${Phone3x} 3x`} />
            </div>
            {appStoreLink ? (
                <Button
                    view="brand"
                    size="lg"
                    elementType="a"
                    href={appStoreLink}
                    className={cn({ [css.installAppButton]: true, [css.overBottomButton]: !isPopularBrowser })}
                    onClick={goToAppStore}
                >
                    {titleYellowButton}
                </Button>
            ) : (
                <Button
                    view="brand"
                    size="lg"
                    className={cn({ [css.installAppButton]: true, [css.overBottomButton]: !isPopularBrowser })}
                    onClick={goToAppStore}
                >
                    {titleYellowButton}
                </Button>
            )}
            {!isPopularBrowser ? (
                <Button view="neutral" size="lg" className={css.openAppButton} onClick={openApp}>
                    {i18n('common', 'open-in-app')}
                </Button>
            ) : null}
        </div>
    );
};
